// import ReportEdit from './ReportEdit';
import ReportEdit from './NewEditReportContainer';

export default ReportEdit;



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/report-edit/index.js